export class LoginEmailRequest {
  email: string;
  password: string;
  twoFactorCode: string;

  constructor(email: string, password: string, twoFactorCode?: string) {
    this.email = email;
    this.password = password;
    this.twoFactorCode = twoFactorCode;
  }
}
